import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../config/url";

const OrderTracking = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchSellerOrders = async () => {
      try {
        const token = localStorage.getItem("token"); // Assume token-based authentication
        const response = await axios.get(`${baseurl}/api/order/seller-order`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching seller orders:", error);
      }
    };

    fetchSellerOrders();
  }, []);

  return (
    <div className="p-6 bg-gradient-to-br from-gray-100 to-white min-h-screen">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">Order Tracking</h1>
      <div className="max-w-7xl mx-auto overflow-hidden shadow-lg rounded-lg bg-white">
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-gradient-to-r from-blue-500 to-blue-700 text-white">
              <tr>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Order ID</th>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Customer</th>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Product</th>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Quantity</th>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Status</th>
                <th className="py-3 px-6 text-left text-sm font-semibold tracking-wide">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id} className="hover:bg-gray-50 transition-colors">
                  <td className="py-4 px-6 border-b text-gray-700">{order._id}</td>
                  <td className="py-4 px-6 border-b text-gray-700">{order.user.name}</td>
                  <td className="py-4 px-6 border-b text-gray-700">
                    {order.items.map((item) => item.product.name).join(", ")}
                  </td>
                  <td className="py-4 px-6 border-b text-gray-700">
                    {order.items.reduce((sum, item) => sum + item.quantity, 0)}
                  </td>
                  <td className="py-4 px-6 border-b text-gray-700">{order.status}</td>
                  <td className="py-4 px-6 border-b">
                    <button
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                      onClick={() => navigate("/order-details", { state: { order } })}
                    >
                      Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderTracking;
